import axios from '../axios'
import Vue from 'vue'

export const addMessage = (data) => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/webgroupmsg',
    method: 'post',
    data
  })
}

export const getMessageList = (data) => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/webgroupmsg',
    method: 'get',
    params: data
  })
}

export const delMessage = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/cms/webgroupmsg',
    method: 'delete',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/adminMessage.js